import React, { Component } from 'react';
import { toast } from 'react-toastify';

import { updCupos, consultaCupos } from "../../../funciones/AdmisionFunction";

class CuposNvoIngreso extends Component {
    state = {
        icono: {
            icon: "fa fa-spinner fa-spin",
            color: "9a9a9a"
        },
        cupos: "",
        disabled: true
    }

    constructor (props) {
        super (props);
        consultaCupos(props.datos.value, props.periodo.id, (resp)=> {
            this.setState({
                cupos: resp,
                disabled: false,
                icono: {
                    icon: "fa fa-circle",
                    color: "9a9a9a"
                },
            })
        })
    }

    componentWillReceiveProps = (props) => {
        this.setState({
            icono: {
                icon: "fa fa-spinner fa-spin",
                color: "9a9a9a"
            },
            cupos: "",
            disabled: true
        }, () => {
            consultaCupos(props.datos.value, props.periodo.id, (resp)=> {
                this.setState({
                    cupos: resp,
                    disabled: false,
                    icono: {
                        icon: "fa fa-circle",
                        color: "9a9a9a"
                    },
                })
            })
        })
        
    }

    cambiaValor = (prop) => (e) => {
        this.setState({ [prop]: e.target.value })
    }

    update = () => {
        let { datos, periodo } = this.props;
        if (this.state.cupos === "") return null;

        this.setState({
            icono: {
                icon: "fa fa-spinner fa-spin",
                color: "9a9a9a"
            }
        }, () => {
            updCupos (datos.value, datos.label, this.state.cupos, periodo.id, (resp)=> {
                this.setState({
                    icono: resp[1]
                },() => {
                    toast[resp[0].status](resp[0].mensaje,{autoClose: 4000});
                })
            })
        })
    }

    render() {
        let { icono, cupos, disabled } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <tr>
                <td style={styles}>{this.props.datos.label}</td>
                <td style={styles}>
                    <input className="form-control" disabled={disabled} value={cupos} onChange={this.cambiaValor("cupos")} onBlur={ this.update } title="Ingresa la cantidad de cupos para nuevo ingreso para esta carrera"/>
                </td>
                <td width="50px" align="center"><i style={{fontSize: 9, color: icono.color}} className={icono.icon}></i></td>
            </tr>
        );
    }
}
 
export default CuposNvoIngreso;


// WEBPACK FOOTER //
// ./src/views/Registros/PreferenciasContent/CuposNvoIngreso.jsx